// extracted by mini-css-extract-plugin
export default {"InputBox":"sendNotificationForm_InputBox__xAGPs"};